// extracted by mini-css-extract-plugin
export default {"products_title_container":"PageTitle_products_title_container__yGC6R","title_container":"PageTitle_title_container__Vircs"};